






































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Warning from '@/components/page/Warning.vue';
import PageScope from '@/components/common/PageScope.vue';
import { EnumPersistenceStatus } from '@/api/com/MetaPattern/Core/Infrastructure/Common/EnumPersistenceStatus';
import { UIModelComponent } from '@/api/com/MetaPattern/MDA/MD/UIModel/UIModelComponent';
import { UIPageGroup } from '@/api/com/MetaPattern/MDA/MD/UIModel/UIPageGroup';
import { UIPage } from '@/api/com/MetaPattern/MDA/MD/UIModel/UIPage';
import { MDRepository } from '@/libs/com/MetaPattern/MDA/MD/MDRepository';

@Component({
  components: {
    Warning,
    PageScope
  }
})
export default class UIPageGroupEditor extends Vue {
  @Prop() pageGroup!: UIPageGroup; // 选中的自定义页面分组
  @Prop() curComponent: UIModelComponent; // 当前操作的UI模型对组件

  /** 选中页面表格行的事件处理 */
  selectPageRow(currentRow: UIPage, oldRow: any) {
    if (currentRow) {
      this.$store.dispatch('ModuleMD/setCurMDDesignIdAction', currentRow.designId);
      this.$store.dispatch('ModuleMD/setCurMDElementAction', { element: currentRow });
    }
  }

  /** 删除一行 */
  deleteRow(row: UIPage, e: any) {
    const message = '删除以后不可恢复，是否确定要删除：' + row.displayName;
    this.$confirm(message, '删除提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      if (row.persistenceStatus === EnumPersistenceStatus.Create) {
        this.pageGroup.pages.splice(this.pageGroup.pages.findIndex(item => item.designId === row.designId), 1);
      } else {
        row.persistenceStatus = EnumPersistenceStatus.Delete;
      }
      this.$message({ type: 'info', message: '成功删除自定义页面!' });
      this.curComponent.modify();
    });
    e.stopPropagation();
  }

  /** 添加页面 */
  addPage() {
    const page = MDRepository.createUIPage(null);
    page.pageGroup = this.pageGroup;
    this.pageGroup.pages.push(page);
    this.curComponent.modify();
  }

  get pagesData() {
    return this.pageGroup.pages.filter(item => item.persistenceStatus !== EnumPersistenceStatus.Delete);
  }

  getBooleanStyle(value: boolean) {
    if (value) {
      return 'el-icon-check boolYes';
    }
    return 'el-icon-close boolNo';
  }
}
